(() => {
  // src/js/components/singlefilter.js
  var SingleFilter = class {
    constructor(anchor, post) {
      this.anchor = anchor;
      this.post = post;
    }
    static create() {
      const anchors = window.Store.app.theBody.querySelectorAll(".js-single-filter");
      if (!anchors.length)
        return null;
      let filters_tree = [];
      anchors.forEach((anchor) => {
        const post = anchor.dataset.post;
        const obj = new SingleFilter(anchor, post);
        obj.listener();
        filters_tree.push(obj);
      });
      return filters_tree;
    }
    listener() {
      this.anchor.addEventListener("click", () => {
        window.Store.data.single_filter_value = this.post;
      });
    }
  };
  function render() {
    window.Store.components.singlefilter.obj = SingleFilter.create();
  }
  window.Store.components.singlefilter = {
    obj: null,
    render: null
  };
  window.Store.components.singlefilter.render = render;
})();
